// Componente raíz de la aplicación
import { Component, HostListener, OnInit, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';

const CONNECTION_ERROR_ROUTE = '/cotizador/error/conexion';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  template: `<router-outlet />`,
})
export class App implements OnInit {
  private readonly router = inject(Router);

  ngOnInit(): void {
    this.redirectToConnectionErrorIfOffline();
  }

  @HostListener('window:offline')
  onOffline(): void {
    this.redirectToConnectionErrorIfOffline();
  }

  private redirectToConnectionErrorIfOffline(): void {
    if (typeof navigator === 'undefined' || navigator.onLine) {
      return;
    }

    if (this.router.url.startsWith(CONNECTION_ERROR_ROUTE)) {
      return;
    }

    void this.router.navigate([CONNECTION_ERROR_ROUTE], {
      queryParams: { entry: 'landing' },
    });
  }
}
